import fetchAPI from '../fetchAPI';

export const callSetTablePreferences = async (
  tableName: string,
  body: TablePrefs
): Promise<iResponse<TablePrefs>> => {
  const response: iResponse<TablePrefs> = await fetchAPI({
    method: `PUT`,
    route: `user/preferences/tables/${encodeURIComponent(tableName)}`,
    data: body
  });

  return response;
};

export default callSetTablePreferences;
